import NewEmpty from '~components/new-chat/empty'

export default NewEmpty
